import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { PartTypeUIMessages } from '../../model/part-type-ui.messages';
import { PartsTypeModel } from '../../model/part-type.model';
import { PartTypeService } from '../../service/part-type.service';
import { PartTypeAddDialogComponent } from '../part-type-add-dialog/part-type-add-dialog.component';

@Component({
  selector: 'app-part-type',
  templateUrl:
    'console/app-js/modules/partType/components/part-type-list/part-type-list.component.html'
})
export class PartTypeListComponent extends APIOperableComponent
  implements OnInit {
  @ViewChild('statusCombobox', { static: true }) statusCombobox;
  public pageSize = 100;
  public skip = 0;
  public gridView: GridDataResult;
  public sort: SortDescriptor[] = [
    {
      field: 'name',
      dir: 'asc'
    }
  ];
  public selectedStatus = 'Active and Inactive';
  public partTypes: Array<PartsTypeModel> = [];
  public allPartTypes: Array<PartsTypeModel> = [];
  public statuses: Array<string> = [
    'Active and Inactive',
    'Active',
    'Inactive'
  ];
  public partTypeInputData: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected progressService: NgProgress,
    private dialogService: UIDialogService,
    protected toastr: ToastrService,
    protected authService: AuthService,
    protected partTypeService: PartTypeService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    this.getPartTypes();
  }

  public getPartTypes(): void {
    this.partTypeService.getPartTypes().subscribe(data => {
      this.allPartTypes = data;
      this.partTypes = this.allPartTypes;
      this.loadPartTypes();
    });
  }

  public filterData(): void {
    this.partTypes = this.allPartTypes.filter(partType => {
      if (this.selectedStatus === 'Active') {
        return partType.isActive;
      }
      if (this.selectedStatus === 'Inactive') {
        return !partType.isActive;
      }
      return true;
    });
    if (this.partTypeInputData) {
      this.partTypes = this.partTypes.filter(partType => {
        return (
          partType.name
            .toLowerCase()
            .indexOf(this.partTypeInputData.toLowerCase()) !== -1 ||
          !this.partTypeInputData
        );
      });
    }
    this.skip = 0;
    this.loadPartTypes();
  }

  public canManageParts(): boolean {
    return this.authService.isAssetManager() || this.authService.isAdmin();
  }

  public loadPartTypes(): void {
    this.gridView = {
      data: this.partTypes.slice(this.skip, this.skip + this.pageSize),
      total: this.partTypes.length
    };
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.sortProducts();
  }

  public sortProducts(): void {
    this.gridView = {
      data: orderBy(this.partTypes, this.sort),
      total: this.partTypes.length
    };
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadPartTypes();
  }

  public statusChanged(partType: PartsTypeModel) {
    partType.isActive = !partType.isActive;
    this.startProgress();
    this.partTypeService.updatePartType(partType).subscribe(
      result => {
        if (result.responseCode === 200) {
          this.onAPISuccess(PartTypeUIMessages.UPDATE_PART_TYPE_SUCCESS);
          this.finishProgress();
        } else {
          partType.isActive = !partType.isActive;
          this.onAPIError(PartTypeUIMessages.UPDATE_PART_TYPE_ERROR);
        }
      },
      err => {
        partType.isActive = !partType.isActive;
        this.onAPIError(PartTypeUIMessages.UPDATE_PART_TYPE_ERROR);
      }
    );
  }

  public onAddItem() {
    //need to add part type modal option here
    this.dialogService
      .open(PartTypeAddDialogComponent, [
        { provide: 'partsTypeModel', useValue: null }
      ])
      .then(result => {
        if (result) {
          this.getPartTypes();
        }
      })
      .catch(result => {
        // Silence is golden.
      });
  }
}
